import { jsx as _jsx } from "react/jsx-runtime";
import { TrackedLinkContext } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { useCategoryPageFilterKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useCategoryPageBrandFirstSearchResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageBrandFirstSearchResults";
import { CategoryPageBrandGrid } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/CategoryPageBrandGrid";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import React from "react";
export var BrandFirstResults = function(param) {
    var categoryPageLoadTimingRef = param.categoryPageLoadTimingRef, isLoading = param.isLoading, requestId = param.requestId, headerText = param.headerText, categoryModel = param.categoryModel, isScrollingToTop = param.isScrollingToTop, onFirstBatchVisible = param.onFirstBatchVisible, shouldRenderExtraTileOnXLScreen = param.shouldRenderExtraTileOnXLScreen;
    var brandFirstSearchResults = useCategoryPageBrandFirstSearchResults();
    var filterKeys = useCategoryPageFilterKeys();
    return /*#__PURE__*/ _jsx("div", {
        style: {
            position: "relative"
        },
        ref: categoryPageLoadTimingRef,
        children: /*#__PURE__*/ _jsx(TrackedLinkContext.Provider, {
            value: {
                type: IClickInfo.Type.BRAND,
                requestId: requestId,
                containerName: "marketplace_maker_grid"
            },
            children: /*#__PURE__*/ _jsx(CategoryPageBrandGrid, {
                title: headerText,
                pageType: PAGE_TYPE.CATEGORY,
                isLoading: isLoading,
                category: categoryModel,
                filterKeys: filterKeys,
                searchResults: isLoading ? [] : brandFirstSearchResults,
                requestId: requestId,
                isScrollingToTop: isScrollingToTop,
                onFirstBatchVisible: onFirstBatchVisible,
                itemsPerRow: shouldRenderExtraTileOnXLScreen ? {
                    mobileAndAbove: 2,
                    tabletAndAbove: 4,
                    xLargeAndAbove: 5
                } : undefined
            })
        })
    });
};
